import React, { useState } from 'react';
import { Stack, TextField, PrimaryButton, Text, MessageBar, MessageBarType } from '@fluentui/react';
import { useAuth } from '../context/AuthContext';

export const Login: React.FC = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoggingIn(true);

    const result = await login(email, password);

    if (!result.success) {
      setError(result.error || 'Login fehlgeschlagen');
      setIsLoggingIn(false);
    }
    // Bei Erfolg wird der User automatisch weitergeleitet (durch AuthContext)
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f3f2f1',
    }}>
      <Stack
        tokens={{ childrenGap: 20 }}
        styles={{
          root: {
            width: 400,
            padding: 40,
            backgroundColor: 'white',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            borderRadius: 4,
          },
        }}
      >
        <Text variant="xxLarge" styles={{ root: { fontWeight: 600, textAlign: 'center' } }}>
          Bestellwesen
        </Text>
        <Text variant="medium" styles={{ root: { textAlign: 'center', color: '#605e5c' } }}>
          Anmeldung über das Bögra-Netzwerk
        </Text>

        {error && (
          <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
            {error}
          </MessageBar>
        )}

        <form onSubmit={handleSubmit}>
          <Stack tokens={{ childrenGap: 15 }}>
            <TextField
              label="Email"
              placeholder="vorname.nachname@boegra.com"
              value={email}
              onChange={(_, newValue) => setEmail(newValue || '')}
              required
              disabled={isLoggingIn}
              autoComplete="email"
            />
            <TextField
              label="Passwort"
              type="password"
              placeholder="Ihr Windows/Email Passwort"
              value={password}
              onChange={(_, newValue) => setPassword(newValue || '')}
              required
              disabled={isLoggingIn}
              autoComplete="current-password"
              canRevealPassword
            />
            <PrimaryButton
              text={isLoggingIn ? 'Anmeldung läuft...' : 'Anmelden'}
              type="submit"
              disabled={isLoggingIn || !email || !password}
              styles={{ root: { marginTop: 10 } }}
            />
          </Stack>
        </form>

        <Text variant="small" styles={{ root: { textAlign: 'center', color: '#605e5c', marginTop: 20 } }}>
          Verwenden Sie Ihre Windows/Email-Anmeldedaten
        </Text>
      </Stack>
    </div>
  );
};
